// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3-dfM","title":"FrontImage_title__3ufyC"};